import request from '../utils/request'

const url = '/production'

// 分页条件查询
export const getList = (params) => {
  return request({
    url: url, method: 'get', params
  })
}

export const getListAdd = (params) => {
  return request({
    url: url + '/add/list', method: 'get', params
  })
}

export const add = (data) => {
  return request({
    url: url + '/add/add', method: 'post', data
  })
}

export const edit = (data) => {
  return request({
    url: url + '/add/add', method: 'put', data
  })
}

export const deleteOne = (id) => {
  return request({
    url: url + '/add/' + id, method: 'delete'
  })
}

export const updateAll = (params) => {
  return request({
    url: url + '/all', method: 'post', params
  })
}

// 数据导出
export const getExportApi = (startTime, endTime, code, isGroup, deptId, type) => {
  return 'https://hjgc.xkyun.top/api' + url + '/export/' +startTime+'/'+endTime+'/'+code+'/'+ isGroup+'/'+ deptId + '/' + type
}

// export const getExportApi = (startTime, endTime, code, isGroup, deptId, type) => {
//   return "http://localhost:" + process.env.VUE_APP_PORT + url + "/export/" +startTime+'/'+endTime+'/'+code+'/'+ isGroup+'/'+ deptId + '/' + type
// }
